import React from 'react';
import {
    Button,
    Form,
    Input,
    Icon,
    TextArea,
    Segment,
    Grid,
    Loader,
    Header,
    Radio,
    Select,
    Message,
    Card,
    Divider
} from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { ToastContainer } from 'react-toastify';


export default class AnswerQuestionPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            showDeleteButton: this.props.showDeleteButton,
            admin: !!((localStorage.getItem('activeRole').startsWith('Administrator') || localStorage.getItem('activeRole').startsWith('QA admin:')))

        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {


    }


    // handleChange = (e, { value }) => {this.setState({ value },  };
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        let question = {
            text: this.props.text,
            questionId: this.props.questionId,
            typeName: this.props.typeName,
        };
        return (
            <div>


                <Form >

                    <Grid columns={2} centered stackable >
                        <Grid.Column width={16} stretched>
                            {/* <Form.Field required error={this.state.answerErr}> */}

                            {/*    <FormattedMessage id="common.inputIndex"> */}
                            {/*        {(msg) => (<input */}
                            {/*            required */}
                            {/*            fluid */}
                            {/*            placeholder={msg} */}
                            {/*            control={Input} */}
                            {/*            value={this.state.answer} */}
                            {/*            name="answer" */}
                            {/*            onChange={(e) => { */}
                            {/*                this.setState({ answer: e.target.value }); */}
                            {/*            } */}
                            {/*            } */}
                            {/*            // onChange={this.handleInputChange} */}

                            {/*        />)} */}
                            {/*    </FormattedMessage> */}
                            {/* </Form.Field> */}
                            <Form.Field
                                required
                                error={false}
                                label={<Header as="h4"> <p style={{ color: 'red' }}>*</p>{question.text}  {this.props.showDeleteButton && <Header as="h5" floated="right" ><span style={{ fontSize: '15px' }}>

                                    <Icon name="trash alternate" link onClick={() => { this.props.deleteQuestion(question.questionId); }} > </Icon>


                                </span></Header>} </Header>}
                                fluid
                                control={Input}
                                // label="Odgovor"
                                placeholder="Unesite odgovor"
                                value={this.state.answer}
                                name="answer"
                                onChange={!this.state.admin ? (e) => this.props.submitAnswersQuestion(this.props.questionId, e.target.value, this.props.staff, this.props.typeName) : this.handleInputChange}
                            />
                        </Grid.Column>

                    </Grid>
                </Form>


                {this.props.showDivider && <Divider />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/QuestionPreviews/AnswerQuestionPreview.js